export enum PeriodUnit {
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
}

export enum SubscriptionStatus {
  future = 'future',
  in_trial = 'in_trial',
  active = 'active',
  non_renewing = 'non_renewing',
  paused = 'paused',
  cancelled = 'cancelled',
  transferred = 'transferred',
}

export enum ItemType {
  plan = 'plan',
  addon = 'addon',
  charge = 'charge',
}

export enum DiscountApplyOn {
  invoice_amount = 'invoice_amount',
  specific_item_price = 'specific_item_price',
}

export enum DiscountDurationType {
  one_time = 'one_time',
  forever = 'forever',
  limited_period = 'limited_period',
}

export type Subscription = {
  currency: string;
  customer_id: string;
  id: string;
  period?: number;
  period_unit?: PeriodUnit;
  status: SubscriptionStatus;
  subscription_items: SubscriptionItem[];
  trial_end?: string;
};

export type SubscriptionItem = {
  billing_system_item_price_id: string;
  item_type: ItemType;
  quantity?: number;
  unit_price?: number;
};

export type Discount = {
  amount?: number;
  apply_on: DiscountApplyOn;
  duration_type: DiscountDurationType;
  included_in_mrr?: boolean;
  item_price_id: string;
  label?: string;
  percentage?: number;
  period?: number;
  period_unit?: PeriodUnit;
};
